<script setup lang="ts">
  import type { ApplyProfile } from '~/types/apply'

  // Leave room for ApplyFlow's fixed stepper.
  definePageMeta({ noFooter: true })

  const router = useRouter()

  // Redirect to jobs matching the deposited profile.
  const onDeposited = async (profile?: ApplyProfile | null) => {
    const query: Record<string, string> = {}

    if (profile?.locationSlug) query.ville = profile.locationSlug

    if (profile?.sectors?.length) {
      const sectors = await findAll('sectors', { fields: ['id', 'slug'], sort: { name: 'asc' } })
      const slugs = profile.sectors.map(id => sectors.find(s => s.id === id)?.slug).filter(Boolean)
      if (slugs.length) query.secteur = slugs.join(',')
    }

    await router.push({ path: '/jobs', query })
  }
</script>

<template>
  <Page code="resume">
    <ApplyFlow mode="page" resume-deposit @applied="onDeposited" />
  </Page>
</template>
